// @flow
import React from 'react';

import Box from '@waglabs/box';

import { Layout } from '../components/Layout';
import { HowItWorks } from '../components/WagTag/components/HowItWorks';
import { PlansBlock } from '../components/WagTag/components/PlansBlock';
import { WagTagDescription } from '../components/WagTag/components/WagTagDescription';
import { WagTagHeading } from '../components/WagTag/components/WagTagHeading';
import SEO from '../components/seo';

import { WagTagMeta } from '../metadata';

type Props = {
  location: {
    pathname: string,
    href: string,
    search: string,
  },
};

const HOW_IT_WORKS_DATA = [
  {
    icon: 'dog',
    heading: 'The smarter, simple dog tag',
    subheading: 'Your dog’s Wag! Tag comes with a unique code that links to their personal online profile. To set up, simply scan the code and follow the steps.',
  },
  {
    icon: 'tag',
    heading: 'More than a name',
    subheading: 'Fill your dog’s profile with important info for someone who finds them, like emergency contacts, drop-off locations, health history, and more.',
  },
  {
    icon: 'walker',
    heading: 'Safety in numbers',
    subheading: 'Wag! Tag Complete offers active support if your dog goes missing. We’ll make flyers, post to lost dog platforms, and alert walkers with Wag! to search.',
  },
];

const WagTag = ({
  location: {
    pathname,
    href,
    search,
  },
}: Props) => (
  <Layout
    currentPathname={pathname}
    currentUrl={href}
  >
    <SEO
      title={WagTagMeta.title}
      description={WagTagMeta.description}
      url={href}
      robots={WagTagMeta.robots}
    />

    <WagTagHeading />

    <Box
      display={['block', 'none']}
      mt={2}
    >
      <WagTagDescription
        fontSize={3}
        color="medGray"
        px={3}
      />
    </Box>

    <HowItWorks
      bg="backgroundGray"
      data={HOW_IT_WORKS_DATA}
      sectionTitle="How Wag! Tag Works"
    />

    <PlansBlock
      search={search}
    />
  </Layout>
);

export default WagTag;
